// extracted by mini-css-extract-plugin
export default {"editableButton":"styles_editableButton__Rq4sG"};